import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { id: "index" };
const _hoisted_2 = {
    id: "main-sections",
    class: "center"
};
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/index/scots.jpg",
    alt: "Scots"
}, null, -1 /* HOISTED */);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("figcaption", null, "SCOTS", -1 /* HOISTED */);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", null, "At VMCHS we are very proud of the variety of sports we teach.", -1 /* HOISTED */);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/index/faith.jpg",
    alt: "Faith"
}, null, -1 /* HOISTED */);
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("figcaption", null, "FAITH", -1 /* HOISTED */);
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", null, " Catholic education must provide for each student the opportunity to develop a sense of concern and responsibility. ", -1 /* HOISTED */);
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/index/news.jpg",
    alt: "Photo by Tim Mossholder on Unsplash News"
}, null, -1 /* HOISTED */);
const _hoisted_10 = /*#__PURE__*/ _createElementVNode("figcaption", null, "NEWS", -1 /* HOISTED */);
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("div", null, "All the news regarding our school.", -1 /* HOISTED */);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/index/policy.jpg",
    alt: "Photo by Matt Ragland on Unsplash"
}, null, -1 /* HOISTED */);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("figcaption", null, "ADMISSIONS", -1 /* HOISTED */);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("div", null, " There is no gift greater than education. Investing now in your child’s education will provide better opportunities. ", -1 /* HOISTED */);
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/index/accomplishments.jpg",
    alt: "Photo by Charles DeLoye on Unsplash"
}, null, -1 /* HOISTED */);
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("figcaption", { class: "small" }, "ACCOMPLISHMENTS", -1 /* HOISTED */);
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("div", null, " VMCHS provides a curriculum in which students can investigate a broad education spectrum. ", -1 /* HOISTED */);
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/index/calendar.jpg",
    alt: "Photo by Eric Rothermel on Unsplash"
}, null, -1 /* HOISTED */);
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("figcaption", null, "CALENDAR", -1 /* HOISTED */);
const _hoisted_20 = [
    _hoisted_18,
    _hoisted_19
];
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("div", null, "Here you will find the large number of events that we have monthly.", -1 /* HOISTED */);
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("section", { id: "principals-message" }, [
    /*#__PURE__*/ _createElementVNode("figure", { style: { "background-image": "url(/images/index/principals-message.jpg)" } }, [
        /*#__PURE__*/ _createElementVNode("div", { class: "center" }, [
            /*#__PURE__*/ _createElementVNode("figcaption", null, [
                /*#__PURE__*/ _createElementVNode("p", null, " Welcome to Vincent Memorial Catholic High School Website. Our school has educated many young people and continues to provide quality education in the Imperial and Mexicali Valley. We are committed to Catholic education, spiritual development, values and academic excellence. "),
                /*#__PURE__*/ _createElementVNode("p", null, " VMCHS faculty and staff work together to create a safe and nurturing environment in which students are able to discover their talents, focus more on their studies and get prepared to embrace life’s challenges. "),
                /*#__PURE__*/ _createElementVNode("p", null, [
                    /*#__PURE__*/ _createTextVNode(" ​Thank you all for being part of the Vincent family and for choosing us to be a part of yours."),
                    /*#__PURE__*/ _createElementVNode("br"),
                    /*#__PURE__*/ _createTextVNode(" May the Lord keep us together and give us the graces we need to always do His will. I pray that we strengthen our faith and encourage each other to witness the Gospel values. ")
                ]),
                /*#__PURE__*/ _createElementVNode("p", null, " “Dear young people do not bury your talents, the gifts that God has given you! Do not be afraid to dream of great things!”- Pope Francis. "),
                /*#__PURE__*/ _createElementVNode("p", null, [
                    /*#__PURE__*/ _createElementVNode("span", null, "With prayers and appreciation,"),
                    /*#__PURE__*/ _createElementVNode("br"),
                    /*#__PURE__*/ _createTextVNode(" Sr. Lupita Hernández, SJS VMCHS Principal ")
                ])
            ])
        ])
    ])
], -1 /* HOISTED */);
const _hoisted_23 = {
    id: "student-accomplishments",
    class: "center"
};
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("h2", null, [
    /*#__PURE__*/ _createElementVNode("span", null, "STUDENT ACCOMPLISHMENTS")
], -1 /* HOISTED */);
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("p", null, " VMCHS curriculum conforms to the UC/CSU a-g admission requirements for high school graduates. The following are the Colleges and Universities that granted admission to our students in the last three years: ", -1 /* HOISTED */);
const _hoisted_26 = { id: "calendar" };
const _hoisted_27 = /*#__PURE__*/ _createElementVNode("h4", null, "SCHOOL CALENDAR", -1 /* HOISTED */);
const _hoisted_28 = { class: "center" };
const _hoisted_29 = { class: "title" };
const _hoisted_30 = { class: "month" };
const _hoisted_31 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/calendar-left-arrow.svg",
    alt: "Arrow"
}, null, -1 /* HOISTED */);
const _hoisted_32 = [
    _hoisted_31
];
const _hoisted_33 = { class: "month" };
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("img", {
    src: "/images/calendar-left-arrow.svg",
    alt: "Arrow"
}, null, -1 /* HOISTED */);
const _hoisted_35 = [
    _hoisted_34
];
const _hoisted_36 = { class: "year" };
const _hoisted_37 = { class: "calendar-grid" };
const _hoisted_38 = /*#__PURE__*/ _createStaticVNode("<div class=\"day title weekend\">SUNDAY</div><div class=\"day title\">MONDAY</div><div class=\"day title\">TUESDAY</div><div class=\"day title\">WEDNESDAY</div><div class=\"day title\">THURSDAY</div><div class=\"day title\">FRIDAY</div><div class=\"day title weekend\">SATURDAY</div>", 7);
const _hoisted_45 = ["data-iso"];
const _hoisted_46 = { class: "date" };
const _hoisted_47 = /*#__PURE__*/ _createElementVNode("div", { class: "events" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Banner = _resolveComponent("Banner");
    const _component_router_link = _resolveComponent("router-link");
    const _component_Carrousel = _resolveComponent("Carrousel");
    return (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createVNode(_component_Banner, {
            images: _ctx.bannerImages.items
        }, null, 8 /* PROPS */, ["images"]),
        _createElementVNode("section", _hoisted_2, [
            _createElementVNode("article", null, [
                _createElementVNode("figure", null, [
                    _createVNode(_component_router_link, { to: { name: 'Athletics' } }, {
                        default: _withCtx(() => [
                            _hoisted_3,
                            _hoisted_4
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _hoisted_5
            ]),
            _createElementVNode("article", null, [
                _createElementVNode("figure", null, [
                    _createVNode(_component_router_link, { to: { name: 'Faith' } }, {
                        default: _withCtx(() => [
                            _hoisted_6,
                            _hoisted_7
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _hoisted_8
            ]),
            _createElementVNode("article", null, [
                _createElementVNode("figure", null, [
                    _createVNode(_component_router_link, { to: { name: 'News' } }, {
                        default: _withCtx(() => [
                            _hoisted_9,
                            _hoisted_10
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _hoisted_11
            ]),
            _createElementVNode("article", null, [
                _createElementVNode("figure", null, [
                    _createVNode(_component_router_link, { to: { name: 'Admission' } }, {
                        default: _withCtx(() => [
                            _hoisted_12,
                            _hoisted_13
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _hoisted_14
            ]),
            _createElementVNode("article", null, [
                _createElementVNode("figure", null, [
                    _createVNode(_component_router_link, { to: { name: 'Academics' } }, {
                        default: _withCtx(() => [
                            _hoisted_15,
                            _hoisted_16
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _hoisted_17
            ]),
            _createElementVNode("article", null, [
                _createElementVNode("figure", null, [
                    _createElementVNode("a", {
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.goToCalendar && _ctx.goToCalendar(...args)), ["prevent"]))
                    }, _hoisted_20)
                ]),
                _hoisted_21
            ])
        ]),
        _hoisted_22,
        _createElementVNode("section", _hoisted_23, [
            _hoisted_24,
            _hoisted_25,
            (_ctx.partnerts.count)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_Carrousel, {
                        title: "USA",
                        schools: _ctx.partnerts.getCountry('USA')
                    }, null, 8 /* PROPS */, ["schools"]),
                    _createVNode(_component_Carrousel, {
                        title: "MÉXICO",
                        schools: _ctx.partnerts.getCountry('México')
                    }, null, 8 /* PROPS */, ["schools"]),
                    _createVNode(_component_Carrousel, {
                        title: "CANADA",
                        schools: _ctx.partnerts.getCountry('Canada')
                    }, null, 8 /* PROPS */, ["schools"])
                ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true)
        ]),
        _createElementVNode("section", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("article", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", {
                            class: "arrow left",
                            onClick: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => (_ctx.prevMonth && _ctx.prevMonth(...args)))
                        }, _hoisted_32),
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.currentTxtMonth), 1 /* TEXT */),
                        _createElementVNode("div", {
                            class: "arrow right",
                            onClick: _cache[2] || (_cache[2] =
                                //@ts-ignore
                                (...args) => (_ctx.nextMonth && _ctx.nextMonth(...args)))
                        }, _hoisted_35)
                    ]),
                    _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.date.getFullYear()), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weeks, (week, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(week, (day, index) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: index,
                                    "data-iso": day.iso,
                                    class: _normalizeClass({
                                        day: true,
                                        empty: day.type == 'next' || day.type == 'previous',
                                        weekend: index == 0 || index == 6,
                                    })
                                }, [
                                    _createElementVNode("div", _hoisted_46, _toDisplayString(day.date), 1 /* TEXT */),
                                    _hoisted_47
                                ], 10 /* CLASS, PROPS */, _hoisted_45));
                            }), 128 /* KEYED_FRAGMENT */))
                        ], 64 /* STABLE_FRAGMENT */));
                    }), 128 /* KEYED_FRAGMENT */))
                ])
            ])
        ])
    ]));
}
